import slice from './slice';

export const { setDisplayNoFlyZones, setDisplaySafeLandZones, setHoveredNoFlyZoneId } = slice.actions;